(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'toggle',
    (event) => {
      const item = event.target;
      if (!(item instanceof HTMLDetailsElement)) return;
      if (!item.classList.contains('faq-ss__item') || !item.open) return;

      const root = item.closest('[data-faq-section]');
      if (!root) return;

      root.querySelectorAll('details.faq-ss__item[open]').forEach((other) => {
        if (other !== item) other.open = false;
      });
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-testimonials"] && !Shopify.designMode) return;
  try {
    
  class ReviewsTestimonialsSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.viewport || !this.track) return;

      this.originalSlides = Array.from(this.track.querySelectorAll('[data-slide]:not([data-clone])'));
      if (this.originalSlides.length === 0) return;
      this.initialized = true;

      this.buildClones();
      this.index = this.originalSlides.length;
      this.perView = 1;
      this.animating = false;
      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);
      this.onResize = () => this.layout();

      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.viewport);
      this.bindSwipe();
      this.layout();
    }

    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.unbindSwipe();
    }

    buildClones() {
      this.track.querySelectorAll('[data-clone]').forEach((node) => node.remove());
      const clones = this.originalSlides.map((slide) => this.cloneSlide(slide));
      clones.forEach((clone) => this.track.appendChild(clone));
      clones
        .map((clone) => clone.cloneNode(true))
        .reverse()
        .forEach((clone) => this.track.insertBefore(clone, this.track.firstChild));
    }

    cloneSlide(slide) {
      const clone = slide.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.removeAttribute('data-shopify-editor-block');
      return clone;
    }

    columns() {
      if (window.matchMedia('(min-width: 1024px)').matches) return Number(this.dataset.desktop) || 3;
      if (window.matchMedia('(min-width: 768px)').matches) return Number(this.dataset.tablet) || 3;
      return Number(this.dataset.mobile) || 1;
    }

    gap() {
      const styles = getComputedStyle(this.track);
      return parseFloat(styles.columnGap || styles.gap) || 0;
    }

    layout() {
      this.perView = this.columns();
      const count = this.originalSlides.length;
      const canSlide = count > this.perView;

      if (this.prev) this.prev.hidden = !canSlide;
      if (this.next) this.next.hidden = !canSlide;

      const width = this.viewport.clientWidth;
      const gap = this.gap();
      const slideWidth = (width - gap * (this.perView - 1)) / this.perView;

      this.track.querySelectorAll('[data-slide]').forEach((slide) => {
        slide.style.width = `${slideWidth}px`;
      });

      if (!canSlide) {
        this.index = count;
        this.setOffset(false);
        return;
      }

      this.setOffset(false);
    }

    go(direction) {
      const count = this.originalSlides.length;
      if (count <= this.perView || this.animating) return;
      this.index += direction;
      this.setOffset(true);
    }

    setOffset(animate) {
      const gap = this.gap();
      const slide = this.originalSlides[0];
      const step = slide.getBoundingClientRect().width + gap;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.animating = animate && !reduce;
      this.track.style.transition = this.animating ? 'transform 0.3s ease' : 'none';
      this.track.style.transform = `translate3d(${-this.index * step}px,0,0)`;

      if (!this.animating) {
        this.normalizeIndex();
        return;
      }

      const onEnd = (event) => {
        if (event && event.target !== this.track) return;
        this.track.removeEventListener('transitionend', onEnd);
        this.normalizeIndex();
        this.animating = false;
      };
      this.track.addEventListener('transitionend', onEnd);
    }

    normalizeIndex() {
      const count = this.originalSlides.length;
      if (count <= this.perView) return;
      let jumped = false;
      if (this.index >= count * 2) {
        this.index -= count;
        jumped = true;
      } else if (this.index < count) {
        this.index += count;
        jumped = true;
      }
      if (jumped) this.setOffset(false);
    }

    bindSwipe() {
      this.pointerStart = null;
      this.onPointerDown = (event) => {
        if (event.touches) this.pointerStart = event.touches[0].clientX;
        else this.pointerStart = event.clientX;
      };
      this.onPointerUp = (event) => {
        if (this.pointerStart == null) return;
        const x = event.changedTouches ? event.changedTouches[0].clientX : event.clientX;
        const delta = x - this.pointerStart;
        this.pointerStart = null;
        if (Math.abs(delta) < 40) return;
        this.go(delta < 0 ? 1 : -1);
      };
      this.viewport.addEventListener('touchstart', this.onPointerDown, { passive: true });
      this.viewport.addEventListener('touchend', this.onPointerUp, { passive: true });
    }

    unbindSwipe() {
      if (!this.viewport) return;
      this.viewport.removeEventListener('touchstart', this.onPointerDown);
      this.viewport.removeEventListener('touchend', this.onPointerUp);
    }
  }

  if (!customElements.get('reviews-testimonials-slider')) {
    customElements.define('reviews-testimonials-slider', ReviewsTestimonialsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
